// extracted by mini-css-extract-plugin
module.exports = {"lang_selector":"Language_lang_selector__9SzMj"};